<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.entrance.entranceName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="entranceId">
              <a-select v-model="model.entranceId" @change="entranceChange" disabled>
                <a-select-option v-for="(item,index) in entrancelist" :key="index.toString()" :value="item.id">
                  {{ item.entranceName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!--<a-col :span="24">
            <a-form-model-item :label="language['emp.col.colLevel_one']" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="parentColId" @change="parentColChange" disabled>
                <a-select-option v-for="(item,index) in topCol" :key="index.toString()" :value="item.id">
                  {{ item.colName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item :label="'上级栏目'" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<a-select v-model="parentColId" @change="parentColChange" disabled>
                <a-select-option v-for="(item,index) in topCol" :key="index.toString()" :value="item.id">
                  {{ item.colName }}
                </a-select-option>
              </a-select>-->
              <a-span style="font-size: 15px;font-weight: 800;">{{colPath}}</a-span>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.colCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colCode">
              <a-input v-model="model.colCode" :placeholder="language['common.auto']"  disabled></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.classificationName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colName">
              <a-input v-model="model.colName"  style="width: 80%"></a-input>
              <a-button @click="languageModelOpen('emp_col_tbl','col_name',colNameLanguages)" type="primary"  style="left: 3%"  :disabled="formDisabled">{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['ad.image']" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="model.colImg" :upload-source="uploadSource" ></j-image-upload>
            </a-form-model-item>
          </a-col>
          <!--<a-col :span="24" v-if="model.colLevel == '1'">
            <a-form-model-item label="模板类型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="templateType">
              <j-dict-select-tag placeholder="请输入模板类型" type="list" v-model="model.templateType" dictCode="hhemp_template_type"  :disabled="!!model.id"/>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.publishStatusName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishStatus">
              <j-dict-select-tag v-model="model.publishStatus" :type="'radio'" dictCode="hhemp_publish_status" :readOnly="true" disabled/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
             <a-form-model-item :label="language['emp.col.publisher']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publisher" v-show="colVisible==true">
               <a-input v-model="model.publisher" placeholder=""  :readOnly="true" disabled></a-input>
             </a-form-model-item>
           </a-col>
           <a-col :span="24">
             <a-form-model-item :label="language['emp.col.publishTime']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishTime" v-show="colVisible==true">
               <j-date placeholder="" v-model="model.publishTime"  style="width: 100%" :readOnly="true" date-format="YYYY-MM-DD HH:mm:ss" />
             </a-form-model-item>
           </a-col>
          <!--<a-col :span="24">
            <a-form-model-item label="发布应用" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishApplications">
              <j-multi-select-tag type="checkbox" v-model="model.publishApplications" dictCode="hhemp_applications" placeholder="请选择发布应用" />
            </a-form-model-item>
          </a-col>-->

          <!--<a-col :span="24">
            <a-form-model-item label="內容数（分类数）" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="detailNumber" v-show="colVisible==true">
              <a-input v-model="model.contentNumber" placeholder="" style="width: 100%" :readOnly="true" disabled/>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.sortNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number :min="1" :max="9999" v-model="model.sortNo"  style="width: 100%" :placeholder="language['common.pleaseInput']+language['emp.col.sortNo']" :disabled="this.disabled"/>
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="24">
            <a-form-model-item label="刪除标示" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="delFlag">
              <a-input v-model="model.delFlag" placeholder="请输入刪除标示"  ></a-input>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-input v-model="model.remark" :placeholder="language['common.pleaseInput']+language['emp.col.remark']" style="width: 80%"></a-input>
              <a-button @click="languageModelOpen('emp_col_tbl','remark',remarkLanguages)" type="primary"  style="left: 3%"  :disabled="formDisabled">{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
        <language-model ref="languageModel" @ok="languageOk"></language-model>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import LanguageModel from "@/components/LanguageModel"
export default {
  name: 'CmsColTblChildrenForm',
  components: {
    LanguageModel
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      parentColId:"",
      uploadSource:"hhemp",
      model:{
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
    /*colCode: [
    { required: true, message: '请输入栏位编号!'},
     { validator: (rule, value, callback) => validateDuplicateValue('cms_col_tbl', 'col_code', value, this.model.id, callback)},
        ],*/
        colName: [
          { required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['emp.col.colName']},
          /*{ pattern: /^.{6,18}$/, message: '请输入6到18位任意字符!'},*/
          /*{ validator: (rule, value, callback) => validateDuplicateValue('cms_col_tbl', 'col_name', value, this.model.id,'0', callback)},*/
          {max: 200, message: this.$store.getters.language['common.lengthUnder'] + '100', trigger: 'blur'}
        ],
        templateType: [
          { required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['emp.col.colName']},
        ],
        sortNo: [
          {required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['emp.col.sortNo']},
          /*{validator: this.validateToSortNo, trigger: 'blur'}*/
        ],
        /*entranceId:[{ required: true, message: '请选择入口!'},]*/
    /*publishStatus: [
      { required: true, message: '请输入发布状态!'},
        ]*/
      },
      url: {
        add: "/hhemp/col/cmscoltbl",
        edit: "/hhemp/col/cmscoltbl",
        queryById: "/hhemp/col/cmscoltbl/"
      },
      colVisible: false,
      entrancelist:[],
      topCol:[],
      colNameLanguages:[],
      remarkLanguages:[],
      colPath:"",
    }
  },
  computed: {
    languageOk(map) {
      if (map && map.dataColumn == 'col_name') {
        this.colNameLanguages = map.languagelist;
      }
      if (map && map.dataColumn == 'remark') {
        this.remarkLanguages = map.languagelist;
      }
    },
    formDisabled(){
      return this.disabled
    },
    language() {
      return this.$store.getters.language
    },
  },
  created () {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model));
    this.initEntrancelist();
  },
  methods: {
    languageModelOpen(dataTable, dataColumn, languagelist) {
      this.$refs.languageModel.edit("hhemp", dataTable, dataColumn, this.model.id, languagelist, this.disabled);
    },
    initEntrancelist(){
      getAction("/hhemp/entrance/empcmsentrances",{"status":"Y"}).then(res=>{
        if(res.success){
          this.entrancelist = res.result;
        }
      })
    },
    initTopCol(entranceId){
      this.topCol = [];
      if(!entranceId){
        return;
      }
      getAction("/hhemp/col/cmscoltbls/queryallListByLevel",{"colLevel":"1","entranceId":entranceId}).then(res=>{
        if(res.success){
          this.topCol = res.result;
        }
      })
    },
    entranceChange(v){
      this.parentColId = '';
      this.initTopCol(v)
    },
    parentColChange(v){
      this.parentColId = v
    },
    add (parentData) {
      //this.edit(this.modelDefault);
      this.edit({publishStatus:'unpublished',parentColId:parentData.id,entranceId:parentData.entranceId});
      this.colVisible = false;
    },
    edit (record) {
      console.log("record.id:",record.id)
      this.initLanguagetemp('emp_col_tbl', 'col_name', record.id)
      this.initLanguagetemp('emp_col_tbl', 'remark', record.id)
      this.model = Object.assign({}, record);
      this.visible = true;
      this.colVisible = true;
      // this.initTopCol(this.model.entranceId)
      this.parentColId = record.parentColId
      this.initColPath(record.parentColId);
    },
    initColPath(parentColId){
      getAction("/hhemp/col/getVOById",{id:parentColId,entranceCode:this.$store.getters.applicationCode}).then(res=>{
        if(res.success){
          let vo = res.result;
          this.colPath = vo.colPath;
        }
      })
    },
    initLanguagetemp(dataTable, dataColumn, dataId) {
      getAction("/sys/syslanguagedata/querylistby", {
        applicationCode: "hhemp",
        dataTable: dataTable,
        dataColumn: dataColumn,
        dataId: dataId
      }).then((res) => {
        if (res.success) {
          if (dataColumn == 'col_name') {
            this.colNameLanguages = res.result;
          }
          if (dataColumn == 'remark') {
            this.remarkLanguages = res.result;
          }
        }
      })
    },
    submitForm () {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          this.model.parentColId = this.parentColId
          if(!this.model.id){
            httpurl+=this.url.add;
            method = 'post';
          }else{
            httpurl+=this.url.edit;
            method = 'put';
          }
          this.model.colLevel = '2';
          this.model.colNameLanguages=this.colNameLanguages;
          this.model.remarkLanguages=this.remarkLanguages
          httpAction(httpurl,this.model,method).then((res)=>{
            if(res.success){
              that.$message.success(res.message);
              that.$emit('ok');
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }

      })
    },
    validateToSortNo(rule, value, callback){
      if(value<1||value>500){
        callback("输入的值在1到500之间！");
      }
    },
  }
}
</script>
